import React, { Component } from 'react';
import axios from 'axios';
import CheckboxContainer from './CheckboxContainer.js'; //component that contains the radio inputs with the lov values
import Input from '../component/Input.js';
import Submit from '../component/Submit.js';
import {path} from './routes.js';
import Select from 'react-select';
import loader from '../asset/img/loader.gif';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import Validation from './Validation.js';
import SelectBox from '../component/Select.js';
import Searchable from '../component/Searchable.js';

export default class CreateThankyou extends Component{
	constructor(props){
		super(props);
		this.state = {
			To:'Select',
			For:'',
			value:'',
			From:this.props.userInfo.userID,
			virtues:[],
			employees:[],
			required:[],
			success:'',
			loading:false,
			valid:true,
			searchVal:''
		};
		this.handleInput = this.handleInput.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	loadingFunc(loading){ //method for displaying loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false});
		}
	}

	componentDidMount(){ //when component mounts, retrieve all active lov values and all active employees
		axios({ //get lov values
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'virtues'}
		}).then((response)=>{
			let values = [];
			let data = response.data.data;
			data.forEach((virtues)=>{
				values.push(virtues);
			});
			this.setState({virtues:values});
		}).then(()=>{
				axios({ //get employees
				method:'post',
				url: path,
				data:{endpoint:'info',table:'users',action:'employees'}
			}).then((response)=>{
				let employees = [];
				let res = response.data.data;
				res.forEach((employee)=>{
					if(employee.name !== this.props.userInfo.name){
						employees.push({value:employee.name,label:employee.name});
					}
				});
				this.setState({employees:employees});
			});
		});
	}

	openModal(){ //method to open the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method to close the modal
		this.setState({modalIsOpen:false});
		this.setState({success:''});
	}

	handleSelect(value){ //method to handle change of employee dropdown
		this.setState({To: value, searchVal: value});
	}

	handleSearch(value){
		this.setState({searchVal: value});
	}

	handleInput(identity,value){ //standard method to handle user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	handleSubmit(){ //method that is called when submit button is clicked
		let checked_button = document.querySelector('input[name="virtues"]:checked');
		if (checked_button !== null){
			checked_button.checked = false; //clear the radio buttons
		}
		let submittable = {To:this.state.To,For:this.state.For,value:this.state.value};
		let emptykeys = [];
		let valid = true;
		for(let field in submittable){ //make sure all fields contain input
			if(submittable[field] === '' || submittable[field] === 'Select'){
				emptykeys.push(field);
			}
		}
		let reason = this.state.For.trim();
		if(this.state.For.trim() !== '' && !Validation("reason",this.state.For)){ //validate the thank you reason
			this.setState({valid:false});
			valid = false;
		}else{
			this.setState({valid:true});
		}
		if(emptykeys.length === 0 && valid){ //if all fields are filled and contain valid input, create thankyou
			this.loadingFunc(true);
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{"endpoint":'create',"table":'thank',"misc":'create',"firstID":this.state.From,"answer":this.state.value,"name":this.state.To,"date":'required',"desc":reason}
			}).then((response)=>{
				let data = response.data.data;
				if(data.Message === "Thank you created!"){
					this.setState({To:'Select',For:'',value:''});
					this.props.logChange();
					this.setState({success:data.Message,valid:true,searchVal:''});
					this.loadingFunc(false);
				}
			});
		}else{ //log which fields are empty in the state
			this.setState({required:emptykeys});
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    height:'200px',
		    minHeight:'200px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 200px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};

		const searchableStyles = {
			input:{
				borderWidth: '.125rem',
				borderRadius: '3px 3px 3px 3px',
				borderColor: 'gray',
				height: '32px',
				width: '100%',
				paddingLeft: '10px'
			},
			list:{
				listStyleType:'none',
				backgroundColor: 'white',
				width: '100%',
				maxHeight: '200px',
				overflowY: 'auto',
				margin: '0',
				paddingLeft: '0'
			}
		};
		const selectStyles = "hh2 w-100 br2 bw1 truncate shadow-3";
		let content;
		const styles = "mb3";
		let toRequired;
		let forRequired;
		let valRequired;
		let employeeOptions = this.state.employees.map((employee,i)=>{ //get all employees for dropdown menu options
			return employee.value;
		});
		this.state.required.forEach((emptyField)=>{ //validation messages that appear above/next to their respective fields
			if(emptyField === "To"){
				toRequired = "Required";
			}else if(emptyField === "For"){
				forRequired = "Required Field";
			}else if(emptyField === "value"){
				valRequired = "Required Field";
			}
		});
		if(!this.state.valid){ //input not valid message
			forRequired = "Input not valid.";
		}
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{ //display success message
			modalContent = <div><div className="fl w-100 tr">
							        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
							        </div>
							        <div className="fl w-100 tc">
							        	<p className="b navy f3">{this.state.success}</p>
							        </div>
							        </div>;
		}
		if(this.props.active){
			content = <div className="mw6-ns center mb3 mt4 pa4 br3 bt bl b--lightest-blue bg-white" style={{boxShadow:'0px 0px 5px 5px #aaaaaa'}}>
									<div className="mw5-ns center b">
										<div className={styles}>
											<div className="pb1">
												<label className="mb2">I Would like to thank:<span className="red">*{toRequired}</span></label>
											</div>
											<div className="br2 pb3">
												<Searchable
													containerId="combo_box_container"
													inputId="combo_box"
													placeholder="Search or Select"
													style={searchableStyles}
													listItemClass="search_list_item"
													caseSensitive={false}
													value={this.state.searchVal}
													options={employeeOptions}
													handleSelect={this.handleSelect}
													handleChange={this.handleSearch}
												/>
											</div>
										</div>
										
										<div className={styles}>
											<div className="pb1">
												<label className="tl">For:<span className="red">*{forRequired}</span></label>
											</div>
											<div className="">
												<Input identity="For" type ="area" onInput={this.handleInput} styles="pa2 br2 bw1 w-100-ns w-100 shadow-3" val={this.state.For}/>
											</div>
										</div>

										<div className={styles}>
											<div>
												<label>Embodied Value:<span className="red">*{valRequired}</span></label>
											</div>
											<div className="mv3">
												<CheckboxContainer identity="value" virtues={this.state.virtues} onCheck={this.handleInput}/>
											</div>
										</div>
										
										<div className="mv3">
											<Submit name="Send" onClick={this.handleSubmit} styles="br3 grow white bn b w-50 h2 bg-blue btshadow"/>
										</div>
									</div>
									<div>
										<Modal
							          isOpen={this.state.modalIsOpen}
							          style={customStyles}
							          contentLabel="loading"
							          shouldCloseOnOverlayClick={false}
							          shouldCloseOnEsc={false}
							        >
							        {modalContent}
							        </Modal>
									</div>
								</div>;
		}
		return(
			<div>
				{content}
			</div>
		);
	}
}

//<SelectBox identity="To" onSelect={this.handleInput} options={employeeOptions} styles={selectStyles} val={this.state.To}/>


// WEBPACK FOOTER //
// ./src/container/CreateThankyou.js